module.exports = __webpack_public_path__ + "static/media/image-011.09cf4958.jpg";